import { createRouter, createWebHashHistory } from 'vue-router';
import Top from '@/components/Top.vue';
import LoginError from '@/components/LoginError.vue';
import CouponForm from '@/components/CouponForm.vue';
import ContractForm from '@/components/ContractForm.vue';
import ContractConfirm from '@/components/ContractConfirm.vue';
import Payment from '@/components/Payment.vue';
import ContractComplete from '@/components/ContractComplete.vue';

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes: [
        {
            path: '/top',
            name: 'Top',
            component: Top,
            meta: {
                title: 'サイトTOP'
            }
        },
        {
            path: '/loginerror',
            name: 'LoginError',
            component: LoginError,
            meta: {
                title: 'このアカウントではこちらのページをご使用になれません'
            }
        },
        {
            path: '/couponForm',
            name: 'CouponForm',
            component: CouponForm,
            meta: {
                title: '申込内容'
            }
        },
        {
            path: '/contractForm',
            name: 'ContractForm',
            component: ContractForm,
            meta: {
                title: '情報入力'
            }
        },
        {
            path: '/contractConfirm',
            name: 'ContractConfirm',
            component: ContractConfirm,
            meta: {
                title: '入力情報の確認'
            }
        },
        {
            path: '/payment',
            name: 'Payment',
            component: Payment,
            meta: {
                title: '支払い方法の入力'
            }
        },
        {
            path: '/contractComplete',
            name: 'ContractComplete',
            component: ContractComplete,
            meta: {
                title: 'お申込み完了'
            }
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'Top',
            component: Top,
            meta: {
                title: 'サイトTOP'
            }
        }
    ],
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        } else {
            // 画面遷移時にスクロールを一番上に移動
            return { top: 0, left: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
    // IDトークンを持たない場合
    if (!document.token) {
        // ブラックリストユーザの場合はLoginError画面に遷移させる
        if (document.isBlackList) {
            if (to.name === 'LoginError') {
                next();
                return;
            }
            next({ name: 'LoginError' });
            return;
        }

        // 未ログインで表示する画面の場合はそのまま
        if (['Top', 'Flow', 'LoginError'].includes(to.name)) {
            next();
            return;
        }

        // 上記以外の場合、TOP画面に移動させる
        next({
            name: 'Top'
        });
        return;
    }

    // IDトークンを持ち、最初に開かれた場合
    if (!from.name) {
        // サービス内容の提示画面の場合はそのまま
        if (['CouponForm'].includes(to.name)) {
            next();
            return;
        }

        // サービス内容の提示画面に移動させる
        next({
            name: 'CouponForm'
        });
        return;
    }

    // 上記以外の場合、要求された画面を表示
    next();
});

// Google Analyticsでのトラッキング用
router.afterEach((to, from) => { // eslint-disable-line no-unused-vars
    // gtag関数が見つからなかった場合はスキップする
    if (typeof gtag !== 'function') { // eslint-disable-line no-undef
        return;
    }

    gtag("set", "linker", { domains: JSON.stringify(["necolico.co.jp", location.hostname]) }); // eslint-disable-line no-undef
    gtag('event', 'page_view', { // eslint-disable-line no-undef
        page_title: to.meta && to.meta.title,
        page_location: "https://" + location.hostname + '/mamolico/nc-s02d02jp-store' + (to.path === '/'? '/top': to.path)
    });
});

export default router;
